import React from "react";
import { compose } from "redux";

import withDesktopNotificationsPanel from "../../../../../hocs/withDesktopNotificationsPanel";
import withTranslations from "../../../../../hocs/withTranslations";
import { buildExclusiveCheckboxFilters } from "../../../../../lib/notifications/buildExclusiveCheckboxFilters";
import { SID_NOTIFICATIONS_TAB_NAME } from "../../../../../lib/notifications/sidNotificationTypes";
import { useStrategyDashboardConfig } from "../../../../../lib/StrategyDashboard/StrategyDashboardContext";
import { ButtonWithArrow } from "../../../common/Typography";
import useIsDesktop from "../../../landingPage/hooks/useIsDesktop";

const StrategyViewAllNotificationsLink = ({
  translate,
  openNotificationsPanel
}) => {
  const dashboard = useStrategyDashboardConfig();
  const isDesktop = useIsDesktop();

  return (
    <div className="flex flex-col align-center w-full px-4 md:px-0">
      <ButtonWithArrow
        withBackground
        className="mt-5 w-full min-w-0 md:min-w-332 md:w-auto md:mt-8 md:mb-4"
        onClick={() =>
          openNotificationsPanel(
            isDesktop,
            SID_NOTIFICATIONS_TAB_NAME,
            buildExclusiveCheckboxFilters(dashboard.notificationTypes)
          )
        }
      >
        {translate("sid_dashboard_view_all_notifications")}
      </ButtonWithArrow>
    </div>
  );
};

export default compose(
  withTranslations,
  withDesktopNotificationsPanel
)(StrategyViewAllNotificationsLink);
